import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A bunch of cool things and neat little tips",
  "description": "",
  "published": "2019-01-14T00:00:00.000Z",
  "redirect_from": ["/blog/cool-things-neat-little-tips/swizec/8871"],
  "categories": "Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You know how some mornings you wake up, jump out of bed, and you're full of piss and vinegar and ready to take on the world?`}</p>
    <p><img parentName="p" {...{
        "src": "/711ba96738142ab1455948a086c875cb/media-GdLU30LovMpig-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`And other days you wake up and it's like you got hit by a cement truck rolling down the hill with no brakes?`}</p>
    <p><img parentName="p" {...{
        "src": "/4844ebc7702c6fc9bb54ea07cd040c8a/media-d0THNFbZHEV4k-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`That.`}</p>
    <p>{`I was going to write today about either `}<a parentName="p" {...{
        "href": "https://github.com/diegohaz/constate"
      }}>{`Constate`}</a>{` and how much I love it for state management, especially with hooks, or about building webapps with `}<a parentName="p" {...{
        "href": "https://github.com/gatsbyjs/gatsby"
      }}>{`Gatsby`}</a>{`.`}</p>
    <p>{`But writing feels a lot like dragging barbed wire through my brain right now, so here's a 2-hour livecoding session instead. We worked on building a webapp with Gatsby and using Constate for state management.`}</p>
    <lite-youtube {...{
      "videoid": "xwyOQqi7Xm8",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`We continue tonight, and on Wednesday, you get an article about it. Deal?`}</p>
    <h2 {...{
      "id": "tips--tricks-i-learned-this-week"
    }}>{`Tips & tricks I learned this week`}</h2>
    <p>{`Let's try a new section for these wonderful Monday emails. Every day, I try to write 200 words about something new I learned. The cute little posts go on to live or die on Twitter and Facebook.`}</p>
    <p>{`But you're my favorite, so I should share them here as well.`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://twitter.com/Swizec/status/1082551586696491008"
        }}>{`An important lesson about JavaScript testing`}</a>{`. You really really have to make sure tests don't run in PhantomJS by accident.`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://twitter.com/Swizec/status/1082918465537695744"
        }}>{`Getting help on Twitter can be absolutely fantastic`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://twitter.com/Swizec/status/1083634802194972672"
        }}>{`Out-of-box Rails caching isn't actually that useful`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://twitter.com/Swizec/status/1084291659829936129"
        }}>{`Novelty makes teaching and sharing easy`}</a>{`. Preserving that enthusiasm as a grizzled veteran ain't easy`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://twitter.com/Swizec/status/1084698389797695488"
        }}>{`README.md is great basic documentation, but you need more`}</a></li>
    </ol>
    <h2 {...{
      "id": "a-few-cool-things"
    }}>{`A few cool things`}</h2>
    <p>{`Here's a bunch of cool things I discovered this week.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://risingstars.js.org/2018/en/"
        }}>{`BestOfJS`}</a>{` released their 2018 findings of most popular repositories. Interestingly Vue is the most popular frontend framework, but the most popular full-stack frameworks and site builders are all based on React. 🤔`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/bluebill1049/react-simple-img"
        }}>{`react-simple-img`}</a>{` is like a better version of my `}<a parentName="li" {...{
          "href": "https://github.com/Swizec/react-lazyload-fadein"
        }}>{`react-lazyload-fadein`}</a>{` component.`}</li>
      <li parentName="ul">{`The Towards Data Science blog published `}<a parentName="li" {...{
          "href": "https://towardsdatascience.com/how-does-the-bay-area-commute-22f45e00419e?gi=a507c2eb50ff"
        }}>{`a really cool study of SF Bay Area commuter regions`}</a>{`. I need to find time to do more machine learning, it's amazing for things like this.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.pewresearch.org/fact-tank/2018/09/06/are-you-in-the-american-middle-class/"
        }}>{`This Pew Research are you middle class`}</a>{` calculator is a beautiful example of how even very simple data visuals can greatly enhance a story.`}</li>
      <li parentName="ul">{`And here's one I've been meaning to share for a while 👉 `}<a parentName="li" {...{
          "href": "https://pudding.cool/"
        }}>{`The Pudding`}</a>{` is an amazing independent blog that publishes data-based stories with beautiful visualizations. Great for inspiration.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      